import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MultimediaDialogComponent } from '@shared/components/container-document-dialog/multimedia-dialog.component';
// SERVICES
import { AnswerService } from '@services/answer/answer.service';
import { QuestionBankService } from '@services/question-bank/question-bank.service';
import { AlertService } from '@services/notification/alert.service';
// MODELS
import { AnswerBase } from '../answer-base';
import { DialogClosed } from '@models/response-api/ResponseApi';
import { RESOURCE_TYPE } from '@constants/ResourceType';

@Component({
  selector: 'app-image-multiple-answer',
  templateUrl: './image-multiple-answer.component.html',
  styleUrls: ['./image-multiple-answer.component.scss']
})
export class ImageMultipleAnswerComponent extends AnswerBase {
  constructor(
    private dialog: MatDialog,
    fb: FormBuilder,
    alertService: AlertService,
    answerService: AnswerService,
    questionBankService: QuestionBankService,
  ) {
    super(fb, alertService, answerService, questionBankService)
  }

  finishLoadData() {}

  async openContainerDocumentDialog() {
    const ref = this.dialog.open(MultimediaDialogComponent, {
      backdropClass: ['ui-backdropClass'],
      panelClass: ['ui-panelClass'],
      minWidth: '380px',
      maxWidth: '600px',
      disableClose: true,
      restoreFocus: false,
      autoFocus: false,
      data: {
        acceptMultimedia: 'image/png, image/gif, image/jpeg',
        resourcesTypes: [RESOURCE_TYPE.images]
      }
    });

    this.subscription.add(
      ref.afterClosed().subscribe((x: DialogClosed) => {
        if (x.success) {
          const answer = this.createAnswer();
          answer.description = x.data.url;
          this.save(answer);
        }
     }))
  }
}
